import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  ClientToolCall,
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'
import type { AgentTemplate } from '@anvil/common/types/agent-template'

const WINDOWED_GLOB_RESULTS = 100

type ToolName = 'glob'
export const handleGlob = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<ToolName>
  agentTemplate: AgentTemplate
  requestClientToolCall: (
    toolCall: ClientToolCall<ToolName>,
  ) => Promise<AnvilToolOutput<ToolName>>
}): Promise<{
  output: AnvilToolOutput<ToolName>
}> => {
  const { previousToolCallFinished, toolCall, agentTemplate, requestClientToolCall } =
    params

  await previousToolCallFinished
  const finalToolCall =
    agentTemplate.windowedFileReads === true &&
    toolCall.input.max_results === undefined
      ? {
          ...toolCall,
          input: { ...toolCall.input, max_results: WINDOWED_GLOB_RESULTS },
        }
      : toolCall
  return { output: await requestClientToolCall(finalToolCall) }
}) satisfies AnvilToolHandlerFunction<ToolName>
